/* global define*/
define('all/player/registration',['jquery'], function ($) {
	'use strict';

	function hideMessage() {
		$('.speech-bubble-info,.speech-bubble-info-down').hide();
		$('.speech-bubble-error,.speech-bubble-error-down').hide();
	}

	function validatePwContent(s) {
		var valid = true;
		var hasAsciiLetter = false;
		var hasNumber = false;
		for (var i = 0; i < s.length; i++) {
			var code = s.charCodeAt(i);
			if (code < 33 || code > 126) {
				valid = false;
				break;
			} else if (!hasAsciiLetter && ((code < 91 && code > 64) || (code < 123 && code > 96))) {
				hasAsciiLetter = true;
			} else if (!hasNumber && code > 47 && code < 58) {
				hasNumber = true;
			}
		}
		if (!hasAsciiLetter) {
			valid = false;
		}
		if (valid && !hasNumber) {
			valid = false;
		}
		return valid;
	}

	// password validation for register popup
	function validatePassword(el) {
		var $el = $(el);
		var password = $el.val();
		var $parent = $el.parentsUntil('form');
		var id = '#' + $el.attr('id');
		var $wrapInitial = $parent.find('#wrap_initial');
		var $basicFields = $wrapInitial.children().children().children();

		var $symbol = $parent.find(id + '-infosymbol');
		$symbol.removeClass('fieldstatus-info');
		$symbol.removeClass('fieldstatus-error');
		$symbol.removeClass('fieldstatus-ok');
		hideMessage();

		var savedMessage = $symbol.data('message');
		if (savedMessage) {
			var $bubble = $symbol.find('.speech-bubble-error');
			$bubble.html(savedMessage);
			$symbol.data('message', '');
		}

		if (password.length === 0) {
			$symbol.addClass('fieldstatus-info');
		}

		var username = $basicFields.find('#PARAM_USER_NAME');
		if (password.length < 5 || !validatePwContent(password) || username.val() === password) {
			$symbol.addClass('fieldstatus-error');
		} else {
			$symbol.addClass('fieldstatus-ok');
		}

		var pwconfirm = $basicFields.find('#PARAM_PASSWORD_CONFIRMATION');
		if (pwconfirm.val().length > 0) {
			validatePasswordConfirmation(pwconfirm);
		}
	}

	// validates password.
	function validatePasswordConfirmation(el) {
		var $el = $(el);
		var passwordconfirm = $el.val();
		var id = '#' + $el.attr('id');
		var $parent = $el.parentsUntil('form');
		var $wrapInitial = $parent.find('#wrap_initial');
		var $basicFields = $wrapInitial.children().children().children();

		var $symbol = $parent.find(id + '-infosymbol');
		$symbol.removeClass('fieldstatus-info');
		$symbol.removeClass('fieldstatus-error');
		$symbol.removeClass('fieldstatus-ok');
		hideMessage();

		if (passwordconfirm.length === 0) {
			$symbol.addClass('fieldstatus-info');
			return;
		}

		var pw = $basicFields.find('#PARAM_PASSWORD');
		var username = $basicFields.find('#PARAM_USER_NAME');
		// Validate format
		if (passwordconfirm !== pw.val() || username.val() === passwordconfirm) {
			$symbol.addClass('fieldstatus-error');
		} else {
			$symbol.addClass('fieldstatus-ok');
		}

	}

	window.registration = {
		validatePassword: validatePassword,
		validatePasswordConfirmation: validatePasswordConfirmation
	};

	return window.registration;
});

